import { render } from "./OrderTableManager.vue?vue&type=template&id=56a37e8e"
import script from "./OrderTableManager.vue?vue&type=script&lang=js"
export * from "./OrderTableManager.vue?vue&type=script&lang=js"

import "./OrderTableManager.vue?vue&type=style&index=0&id=56a37e8e&lang=css"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__